"use client";

import { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Menu, X } from "lucide-react";
import { NAV, SITE } from "@/lib/site";

function isActive(pathname: string, href: string): boolean {
  if (href === "/") return pathname === "/";
  return pathname.startsWith(href);
}

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const pathname = usePathname() || "/";

  return (
    <header className="navbar-solid sticky top-0 z-50">
      <nav className="container-xl flex h-20 items-center justify-between">
        <Link href="/" aria-label={SITE.name} className="flex items-center">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="/images/varano-logo.png"
            alt={SITE.name}
            className="h-[72px] w-auto"
          />
        </Link>

        {/* Desktop nav */}
        <div className="hidden items-center gap-7 lg:flex">
          {NAV.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              data-active={isActive(pathname, item.href)}
              className="nav-link-underline text-sm font-semibold uppercase tracking-wide text-navy"
            >
              {item.label}
            </Link>
          ))}
        </div>

        <Link href="/contact/" className="btn-primary hidden text-sm uppercase lg:inline-flex">
          Request a Quote
        </Link>

        {/* Mobile toggle */}
        <button
          type="button"
          aria-label={mobileOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen((v) => !v)}
          className="text-navy lg:hidden"
        >
          {mobileOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="border-t border-cream-dark bg-white lg:hidden">
          <div className="container-xl flex flex-col py-3">
            {NAV.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="border-b border-cream py-3 text-sm font-semibold uppercase tracking-wide text-navy"
              >
                {item.label}
              </Link>
            ))}
            <Link
              href="/contact/"
              onClick={() => setMobileOpen(false)}
              className="btn-primary mt-4 text-sm uppercase"
            >
              Request a Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
